import { Close, Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  InputAdornment,
  Modal,
  Slide,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import Gene20Box from "../../Components/Gene20Box/Gene20Box";
import Gene20Button from "../../Components/Gene20Button";
import Gene20Typography from "../../Components/Gene20Typography";
import ProductDetails from "./components/productDetails";
import ProductModal from "./components/productModal";

import shopsData from "./data/shopsData";

export default function TheMall() {
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);
  const useStyles = makeStyles(() => ({
    root: {
      width: "100%",
      // padding: "1vw",
      boxSizing: "border-box",
    },
    searchBox: {
      marginBottom: "5vw",
      display: "flex",
      width: "100%",
      justifyContent: "right",
      alignItems: "right",
    },
    searchInput: {
      padding: 0,
      width: "50%",
    },
    productCard: {
      overflow: "hidden",
      border: "1px solid black",
      // padding: "1rem",
      width: "100%",
    },
  }));
  const classes = useStyles();

  return (
    <Gene20Box className={classes.root}>
      <Gene20Box className={classes.searchBox}>
        <TextField
          className={classes.searchInput}
          type="search"
          fullWidth
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Gene20Button
                  variant="contained"
                  color="primary"
                  endIcon={<Search />}
                >
                  search
                </Gene20Button>
              </InputAdornment>
            ),
          }}
        />
      </Gene20Box>
      {/* <Grid container sx={{ width: "100%", display: "flex" }}>
        <Grid
          // key={product.name}
          item
          xs={6}
          sm={4}
          className={classes.productCard}
          sx={{
            display: { xs: "block", sm: "flex" },
            justifyContent: "space-between",
            padding: "1vh",
          }}
        >
          <Gene20Box>
            
          </Gene20Box>
          <Gene20Box sx={{ fontVariant: "all-small-caps" }}> */}
      <ProductDetails toggleModal={toggleModal} />
      <ProductModal toggleModal={toggleModal} show={show} setShow={setShow} />
      {/* </Gene20Box>
          
        </Grid>
      </Grid> */}
    </Gene20Box>
  );
}
